import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

import { z } from "zod";
import { zodParseWithLog } from "../../apiErrorLogs";
import { useDelayedSearch } from "src/utils/useDelayedSearch";

type Options = {
    itemsPerPage?: number;
    page?: number;
    initSearch?: string;
    name?: string;
};

export const useGetAllIngredientLines = (options?: Options) => {
    const { itemsPerPage = 1000, page = 1, initSearch = "", name } = options || {};

    const searchApi = useDelayedSearch({ startSearch: initSearch });

    const query = useQuery({
        queryKey: ["allIngredientLines", { itemsPerPage, page }, name ?? searchApi.delayedSearch],
        queryFn: async () => {
            const url = `/api/ingredient_lines`;
            return await loggedInApiCall.get(url, {
                params: {
                    "order[name]": "asc",
                    itemsPerPage,
                    page,
                    name: (name ?? searchApi.delayedSearch) || null,
                },
            });
        },
        select: (request) => {
            const ingredientLines = request.data["hydra:member"];
            return zodParseWithLog(ingredientLines, IngredientLineZodSchema.array(), "allIngredientLines");
        },
    });

    return {
        allIngredientLines: query.data ?? [],
        searchApi,
        ...query,
    };
};

export type IngredientLine = {
    "@id": IRI;
    id: number;
    name: string;
    canView: boolean;
    canModify: boolean;
    canDelete: boolean;
};

export const IngredientLineZodSchema: z.ZodSchema<IngredientLine> = z.object({
    "@id": z.string(),
    id: z.number(),
    name: z.string(),
    canView: z.boolean(),
    canModify: z.boolean(),
    canDelete: z.boolean(),
});
